export enum RegularizationTabs {
    Regularized,
    Queue,
    Failed
}
